// extracted by mini-css-extract-plugin
export default {"CarModels":"CarModels_CarModels__OS4pf","CarModels__new":"CarModels_CarModels__new__qbje4","CarModels__table":"CarModels_CarModels__table__2RVR5"};